module.exports = __webpack_public_path__ + "static/media/friday-che-routes.c80cd21e.png";